var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companies-button-menu"},[_c('Button',{staticClass:"p-button-rounded button",attrs:{"icon":"pi pi-user","aria-haspopup":"true","aria-controls":"overlay_menu"},on:{"click":_vm.toggle}}),_c('TieredMenu',{ref:"menu",attrs:{"id":"overlay_menu","model":_vm.items,"popup":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }